import {
  FETCH_TERMS_ACCEPTANCE_LOADING,
  FETCH_TERMS_ACCEPTANCE_SUCCESS,
  FETCH_TERMS_ACCEPTANCE_FAILED,
} from "../types";

interface TermsAcceptanceState {
  loading: boolean;
  data: {
    acceptedByName: string;
    accepted: boolean;
  } | null;
  error: string | null;
}

const initialState: TermsAcceptanceState = {
  loading: false,
  data: null,
  error: null,
};

export const termsAcceptanceSummaryReducer = (
  state = initialState,
  action: any
): TermsAcceptanceState => {
  switch (action.type) {
    case FETCH_TERMS_ACCEPTANCE_LOADING:
      return { ...state, loading: action.loading, error: null };
    case FETCH_TERMS_ACCEPTANCE_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case FETCH_TERMS_ACCEPTANCE_FAILED:
      return { ...state, loading: false, error: action.payload, data: null };
    default:
      return state;
  }
};
